import { render, staticRenderFns } from "./StopCustomFieldsList.vue?vue&type=template&id=6d5fcdca&scoped=true&"
import script from "./StopCustomFieldsList.vue?vue&type=script&lang=js&"
export * from "./StopCustomFieldsList.vue?vue&type=script&lang=js&"
import style0 from "./StopCustomFieldsList.vue?vue&type=style&index=0&id=6d5fcdca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5fcdca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d5fcdca')) {
      api.createRecord('6d5fcdca', component.options)
    } else {
      api.reload('6d5fcdca', component.options)
    }
    module.hot.accept("./StopCustomFieldsList.vue?vue&type=template&id=6d5fcdca&scoped=true&", function () {
      api.rerender('6d5fcdca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/components/StopCustomFieldsList.vue"
export default component.exports